import { render } from "./Website.vue?vue&type=template&id=99c72ca4"
import script from "./Website.vue?vue&type=script&lang=ts"
export * from "./Website.vue?vue&type=script&lang=ts"
script.render = render

export default script